import { useLanguage } from "@/contexts/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ContactSection from "@/components/ContactSection";

const Contact = () => {
  const { language, setLanguage, content } = useLanguage();

  return (
    <>
      <Header 
        language={language} 
        onLanguageChange={setLanguage} 
        content={content.header} 
      />
      <main className="min-h-screen">
        <ContactSection content={content.contact} />
      </main>
      <Footer content={content.footer} />
    </>
  );
};

export default Contact;